import createReactComponent from '../createReactComponent';
export default createReactComponent('arrows-diagonal', 'IconArrowsDiagonal', [
  ['path', { d: 'M16 4l4 0l0 4', key: 'svg-0' }],
  ['path', { d: 'M14 10l6 -6', key: 'svg-1' }],
  ['path', { d: 'M8 20l-4 0l0 -4', key: 'svg-2' }],
  ['path', { d: 'M4 20l6 -6', key: 'svg-3' }],
]);
